import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IntlMessages from 'util/IntlMessages';
import config from '../../config';
import {userSignOut} from 'actions/Auth';
import {connect} from 'react-redux'

class UserInfo extends React.Component {

  state = {
    anchorEl: null,
    open: false,
  };

  handleClick = event => {
    this.setState({open: true, anchorEl: event.currentTarget});
  };

  handleRequestClose = () => {
    this.setState({open: false});
  };
  componentDidMount = ()=>{
  //  //console.log("buraya geldiii", this.props)
  }

  render() {
   // //console.log("buraya geldiii 2 ", this.props)
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        {
          this.props.user &&     <Avatar
          alt='...'
          src={config.userAuthApiUrl + this.props.user.profileImageUrl}
          className="user-avatar "
        />
        }
    
        <div className="user-detail">
          <h4 className="user-name" onClick={this.handleClick}> {this.props.userName}<i
            className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
          </h4>
        </div>
        <Menu className="user-info"
              id="simple-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              onClose={this.handleRequestClose}
              PaperProps={{
                style: {
                  minWidth: 120,
                  paddingTop: 0,
                  paddingBottom: 0
                }
              }}>
          {/* <MenuItem onClick={this.handleRequestClose}>
            <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
            <IntlMessages id="popup.profile"/>
          </MenuItem>
          <MenuItem onClick={this.handleRequestClose}>
            <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
            <IntlMessages id="popup.setting"/>
          </MenuItem> */}
          <MenuItem onClick={() => {
         //   this.handleRequestClose();
            this.props.userSignOut()

          }}>
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>

            <IntlMessages id="popup.logout"/>
          </MenuItem>
        </Menu>
      </div>
    );
  }
} 

const mapStateToProps = (state) => {
//  //console.log("stateeeee userinfoo : ",state)
  const locale = state.settings.locale;
  const userName = state.auth.authUser !== null ?  state.auth.authUser.name + ' '+state.auth.authUser.surname : null;
  const user = state.auth.authUser;
  return {locale , userName ,user}
};
export default connect(mapStateToProps, {userSignOut})(UserInfo);

